var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-4", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { attrs: { align: "stretch", "mb-0": "", dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "8" } },
            [
              _c("panel", {
                scopedSlots: _vm._u(
                  [
                    _vm.response
                      ? {
                          key: "header",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n                    Cluster: " +
                                  _vm._s(
                                    _vm.response
                                      ? _vm.response.intclu_rep_accession
                                      : "Loading..."
                                  ) +
                                  "\n                "
                              ),
                            ]
                          },
                          proxy: true,
                        }
                      : null,
                    _vm.response && _vm.response.warning == true
                      ? {
                          key: "toolbar-extra",
                          fn: function () {
                            return [
                              _c("v-chip", { attrs: { color: "error" } }, [
                                _vm._v("Warning"),
                              ]),
                            ]
                          },
                          proxy: true,
                        }
                      : null,
                    _vm.response
                      ? {
                          key: "content",
                          fn: function () {
                            return [
                              _c(
                                "h3",
                                { staticStyle: { "margin-top": "1em" } },
                                [
                                  _vm._v(
                                    "\n                        Cluster summary\n                        "
                                  ),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "span",
                                                  _vm._g({}, on),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g({}, on),
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$MDI
                                                              .HelpCircleOutline
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1692497106
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "Computed across all members of the interface cluster"
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "i.e. after both dimer and interface clustering with Foldseek-Interfaces"
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("dl", { staticClass: "dl-2" }, [
                                _c(
                                  "div",
                                  { staticStyle: { "grid-area": "1/1/2/2" } },
                                  [
                                    _c("dt", [_vm._v("Number of members")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(_vm._s(_vm.response.n_mem)),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticStyle: { "grid-area": "1/2/2/3" } },
                                  [
                                    _c(
                                      "dt",
                                      {
                                        staticClass: "mb-0 d-flex align-center",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v("Interaction Orderedness "),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on }) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        _vm._g({}, on),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            _vm._g(
                                                              {
                                                                attrs: {
                                                                  small: "",
                                                                },
                                                              },
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$MDI
                                                                    .HelpCircleOutline
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              699601995
                                            ),
                                          },
                                          [
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                "Order and disorder categories are based on IUPred2A predictions for interface residues in the unbound state"
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("dd", { staticClass: "mt-0 dd-tight" }, [
                                      _c("svg", {
                                        ref: "barOrderDisorder",
                                        staticClass: "chart",
                                      }),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticStyle: { "grid-area": "2/2/3/3" } },
                                  [
                                    _c("dt", { staticClass: "mb-0" }, [
                                      _vm._v(
                                        "Interface Secondary Structure Composition"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", { staticClass: "mt-0 dd-tight" }, [
                                      _c("svg", {
                                        ref: "barSS",
                                        staticClass: "chart",
                                      }),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "grid-area": "2/1/3/2",
                                      "margin-top": "-1rem",
                                    },
                                  },
                                  [
                                    _c(
                                      "dt",
                                      [
                                        _vm._v(
                                          "\n                            Lowest common ancestor and lineage"
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              plain: "",
                                              text: "",
                                              small: "",
                                              icon: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.showLineage =
                                                  !_vm.showLineage
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { small: "" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.showLineage
                                                      ? _vm.$MDI.ChevronLeft
                                                      : _vm.$MDI.ChevronRight
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.response.lineage == null
                                      ? _c("dd", [_vm._v(" N/A ")])
                                      : !_vm.showLineage
                                      ? _c("dd", [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.response.lineage[0].name
                                              ) +
                                              "                            \n                        "
                                          ),
                                        ])
                                      : _c(
                                          "dd",
                                          _vm._l(
                                            _vm.response.lineage,
                                            function (taxonomy, index) {
                                              return _c(
                                                "span",
                                                { key: taxonomy.id },
                                                [
                                                  _c("TaxSpan", {
                                                    attrs: {
                                                      taxonomy: taxonomy,
                                                    },
                                                  }),
                                                  index <
                                                  _vm.response.lineage.length -
                                                    1
                                                    ? [_vm._v(" » ")]
                                                    : _vm._e(),
                                                ],
                                                2
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("v-divider", {
                                staticStyle: {
                                  "margin-top": "0em",
                                  "margin-bottom": "1em",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center justify-space-between mb-0",
                                },
                                [
                                  _c(
                                    "h3",
                                    [
                                      _vm._v("Representative: "),
                                      _c("ExternalLinks", {
                                        attrs: {
                                          accession:
                                            _vm.response.pdb_id.toUpperCase(),
                                          reference: "PDB",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "mb-1 mt-0 text-body-2" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.response.description)
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.response.protein1_status == true
                                          ? "Protein"
                                          : "Peptide"
                                      ) +
                                      "-" +
                                      _vm._s(
                                        _vm.response.protein2_status == true
                                          ? "Protein"
                                          : "Peptide"
                                      ) +
                                      " |\n                        " +
                                      _vm._s(
                                        _vm.response.iftype1 == 2
                                          ? "Ordered"
                                          : _vm.response.iftype1 == 1
                                          ? "Disordered"
                                          : "Unannotated"
                                      ) +
                                      "-" +
                                      _vm._s(
                                        _vm.response.iftype2 == 2
                                          ? "Ordered"
                                          : _vm.response.iftype2 == 1
                                          ? "Disordered"
                                          : "Unannotated"
                                      ) +
                                      " Interaction\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-simple-table", {
                                staticClass: "representative-table",
                                attrs: { dense: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function () {
                                        return [
                                          _c("thead", [
                                            _c("tr", [
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Chain")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("UniProt")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [
                                                  _vm._v("Taxonomy "),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        plain: "",
                                                        text: "",
                                                        small: "",
                                                        icon: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.showTaxonomy =
                                                            !_vm.showTaxonomy
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { small: "" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.showTaxonomy
                                                                ? _vm.$MDI
                                                                    .ChevronLeft
                                                                : _vm.$MDI
                                                                    .ChevronRight
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Gene Name")]
                                              ),
                                            ]),
                                          ]),
                                          _vm._v(" "),
                                          _c("tbody", [
                                            _c("tr", { staticClass: "row-a" }, [
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(_vm.response.chain1)
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _vm.response.uniprot_id1 !== null
                                                ? _c(
                                                    "td",
                                                    [
                                                      _c("ExternalLinks", {
                                                        attrs: {
                                                          accession:
                                                            _vm.response
                                                              .uniprot_id1,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("td", [_vm._v("N/A")]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm.response.tax_id1 == null
                                                  ? _c("dd", [_vm._v("N/A")])
                                                  : !_vm.showTaxonomy
                                                  ? _c("dd", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.response.tax_id1
                                                            .name
                                                        )
                                                      ),
                                                    ])
                                                  : _c(
                                                      "dd",
                                                      _vm._l(
                                                        _vm.response
                                                          .rep_lineage1,
                                                        function (
                                                          taxonomy,
                                                          index
                                                        ) {
                                                          return _c(
                                                            "span",
                                                            [
                                                              _c("TaxSpan", {
                                                                key: taxonomy.id,
                                                                attrs: {
                                                                  taxonomy:
                                                                    taxonomy,
                                                                },
                                                              }),
                                                              index <
                                                              _vm.response
                                                                .rep_lineage1
                                                                .length -
                                                                1
                                                                ? [
                                                                    _vm._v(
                                                                      " » "
                                                                    ),
                                                                  ]
                                                                : _vm._e(),
                                                            ],
                                                            2
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "max-width": "150px",
                                                  },
                                                  attrs: {
                                                    title:
                                                      _vm.response.gene_name1 ||
                                                      "N/A",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.response
                                                          .gene_name1 || "N/A"
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", { staticClass: "row-b" }, [
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(_vm.response.chain2)
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _vm.response.uniprot_id2 !== null
                                                ? _c(
                                                    "td",
                                                    [
                                                      _c("ExternalLinks", {
                                                        attrs: {
                                                          accession:
                                                            _vm.response
                                                              .uniprot_id2,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("td", [_vm._v("N/A")]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm.response.tax_id2 == null
                                                  ? _c("dd", [_vm._v("N/A")])
                                                  : !_vm.showTaxonomy
                                                  ? _c("dd", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.response.tax_id2
                                                            .name
                                                        )
                                                      ),
                                                    ])
                                                  : _c(
                                                      "dd",
                                                      _vm._l(
                                                        _vm.response
                                                          .rep_lineage2,
                                                        function (
                                                          taxonomy,
                                                          index
                                                        ) {
                                                          return _c(
                                                            "span",
                                                            {
                                                              key: taxonomy.id,
                                                            },
                                                            [
                                                              _c("TaxSpan", {
                                                                attrs: {
                                                                  taxonomy:
                                                                    taxonomy,
                                                                },
                                                              }),
                                                              index <
                                                              _vm.response
                                                                .rep_lineage2
                                                                .length -
                                                                1
                                                                ? [
                                                                    _vm._v(
                                                                      " » "
                                                                    ),
                                                                  ]
                                                                : _vm._e(),
                                                            ],
                                                            2
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "max-width": "150px",
                                                  },
                                                  attrs: {
                                                    title:
                                                      _vm.response.gene_name2 ||
                                                      "N/A",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.response
                                                          .gene_name2 || "N/A"
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1840066424
                                ),
                              }),
                              _vm._v(" "),
                              _vm.response && _vm.response.warning == true
                                ? [
                                    _c("v-divider", {
                                      staticStyle: { "margin-top": "0.5em" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "h3",
                                      {
                                        staticStyle: {
                                          "margin-top": "1em",
                                          color: "#F44336",
                                          "text-decoration": "underline",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Warning!\n                        "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n                            This cluster was wrongly merged with another cluster. We are working on a fix.\n                        "
                                      ),
                                    ]),
                                  ]
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        }
                      : null,
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4" } },
            [
              _c("Panel", {
                staticClass: "repr-structure",
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _vm._v(
                            "\n                    Representative structure\n                "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    _vm.response
                      ? {
                          key: "content",
                          fn: function () {
                            return [
                              _vm.$route.params.cluster
                                ? _c("StructureViewer", {
                                    attrs: {
                                      cluster: _vm.$route.params.cluster,
                                      second: _vm.second,
                                      secondPredicted: _vm.secondPredicted,
                                      bgColorDark: "#2e2e2e",
                                    },
                                    on: {
                                      reset: function ($event) {
                                        _vm.second = ""
                                        _vm.secondPredicted = false
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        }
                      : null,
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-0" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("Members", {
                attrs: { cluster: _vm.$route.params.cluster },
                on: {
                  select: (accession) => {
                    _vm.second = accession
                    _vm.secondPredicted = false
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c("SimilarPredictions", {
            attrs: { cluster: _vm.$route.params.cluster },
            on: {
              select: (accession) => {
                _vm.second = accession
                _vm.secondPredicted = true
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }